import axios from "axios";

// ✅ Debugging info
console.log("🔍 API BASE:", process.env.REACT_APP_API_BASE);
console.log("🔑 Token in reportService:", localStorage.getItem("access_token")); // ✅ fixed key

const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:5000"; // ✅ fallback URL

// ✅ Always use correct JWT key
const getAuthHeaders = () => {
  const token = localStorage.getItem("access_token"); // ✅ fixed key
  if (!token) {
    console.warn("⚠️ No access token found in localStorage!");
  }
  return { Authorization: `Bearer ${token}` };
};

// ✅ Fetch report summary
export const fetchReportSummary = async () => {
  const url = `${API_BASE}/reports/summary`;
  console.log("📡 Fetching report summary from:", url);
  return axios.get(url, { headers: getAuthHeaders() });
};

// ✅ Fetch filtered tasks
export const fetchFilteredTasks = async (filters) => {
  const url = `${API_BASE}/reports/filter`;
  console.log("📡 Fetching filtered tasks from:", url);
  console.log("📊 Filters sent:", filters);
  return axios.post(url, filters, { headers: getAuthHeaders() });
};

// ✅ Export Excel or PDF
export const exportReport = async (format, filters) => {
  const url = `${API_BASE}/reports/export?format=${format}`;
  console.log("📡 Exporting report to:", url);
  const res = await axios.post(url, filters, {
    headers: getAuthHeaders(),
    responseType: "blob",
  });

  // ✅ Trigger download
  const blob = new Blob([res.data]);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute("download", `TaskReport.${format}`);
  document.body.appendChild(link);
  link.click();
};

